import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import './assets/css/index.less';
import './utils/network/request.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Button,
  Input,
  Select,
  Option,
  Form,
  FormItem,
  Loading,
  Notification,
  Popover,
  Dialog
} from 'element-ui';
Vue.use(Button);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Popover);
Vue.use(Dialog);

Vue.use(Loading.directive);
Vue.prototype.$notify = Notification;

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app');
